module.exports = __webpack_public_path__ + "img/rupee.2506cc9c.svg";